<template>
<ReportViewAdendasJugadores :path="path" :excelPath="excelPath" :filterPath="filterPath" :filenamePrefix="filenamePrefix"/>
</template>

<script>
import ReportViewAdendasJugadores from './ReportViewAdendasJugadores'

export default {
  components: {
    ReportViewAdendasJugadores
  },

  data () {
    return {
      path: 'adendas/cuerpo-tecnico/list',
      filterPath: 'filters/adendas',
      excelPath: 'adendas/cuerpo-tecnico/xls',
      filenamePrefix: 'adendas_cuerpo_tecnico'
    }
  }
}
</script>
